module.exports = __webpack_public_path__ + "img/199.cb27288a.jpg";